import React, { useEffect, useState, ChangeEvent } from 'react';
import { Field, Form } from '@ktag/styleguide/dist/react';

import { useTranslation } from 'react-i18next';
import { DrawFeatureProperties } from '@agissc/ktag-map';
import useAppState from '../../../AppStore';
import DrawControlsLabel from './DrawControlsLabel';
import { useTracking } from '../../../utils/tracking/TrackingContext';

const roundRadius = (radius: number) => {
  return Math.round(radius * 100) / 100;
};

const RadiusSetting = () => {
  const { t } = useTranslation('agisviewer');
  const { Tracking } = useTracking();
  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);
  const drawFeatures = useAppState((state) => state.drawFeatures);
  const editDrawFeature = useAppState((state) => state.editDrawFeature);

  const feature = drawFeatures.find(({ id }) => id === selectedFeatureId)!;
  const radius = roundRadius(feature.properties.radius!);
  const [currentValue, setCurrentValue] = useState(radius.toString());
  const [prevRadius, setPrevRadius] = useState<number>(feature.properties.radius!);

  useEffect(() => {
    if (prevRadius !== feature.properties.radius) {
      Tracking.Draw.changeCircleRadius(feature.properties.radius!);
      const updatedRadius = roundRadius(feature.properties.radius!);
      setCurrentValue(updatedRadius.toString());
      setPrevRadius(feature.properties.radius!);
    }
  }, [feature.properties.radius, prevRadius]);

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const cleanValue = e.target.value.replace(/[^0-9.]/g, '') || '0';
    setCurrentValue(cleanValue);
    const parsedValue = parseFloat(cleanValue) || 0;
    editDrawFeature(feature.id as string, {
      properties: { radius: parsedValue } as DrawFeatureProperties,
    });
  };

  const onSubmit = (_: any, { setSubmitting }: any) => {
    setSubmitting(false);
  };

  return (
    <div>
      <DrawControlsLabel>{t('draw_control_radius')}</DrawControlsLabel>
      <Form
        initialValues={{
          radius,
        }}
        onSubmit={onSubmit}
      >
        <Field
          label=""
          name="radius"
          value={currentValue}
          additionalClassNames="draw-settings__radius-input"
          onChange={onChange}
        />
      </Form>
    </div>
  );
};

export default RadiusSetting;
